import { ReactElement } from "react";
import { SystemIcon, LogoIcon } from "@justworkshr/milo-icons";

import { getReferrer } from "lib/referrerApp/referrerApp";

import { ReactComponent as JwSmallLogo } from "./icons/j-logo.svg";
import styles from "./navbar.module.css";

export default function Navbar(): ReactElement {
  const { name, url } = getReferrer();

  return (
    <nav aria-label="app-navbar" className={styles.container}>
      <LogoIcon
        brand="justworks"
        color="black"
        title="Justworks"
        width={160}
        className={styles.jwBigLogo}
      />

      {url && (
        <a href={url} className={styles.link}>
          <SystemIcon
            iconName="arrow-left"
            color="brand"
            className={styles.leftArrow}
          />
          Back{name && ` to ${name}`}
        </a>
      )}

      <JwSmallLogo className={styles.jwSmallLogo} />
    </nav>
  );
}
